import React from "react";

const NotFound = () => {
  return <div>This link may be unavailable or You have no access for this</div>;
};

export default NotFound;
